import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useBulkBookingConflictsForm = () => {
  const { t } = useTranslation();

  // RYDE-7139: `overwrite` and `createIfExistingFormAttributes` were removed together with the
  // "Booking conflicts with an existing ride" radio (superseded by the "Update" / Replace existing
  // bookings checkbox). Please keep this commented — the replacement is still under testing/validation,
  // so do not delete it (kept for easy restore).
  // const overwrite = t("booking.formLabel.conflictsDetails.overwrite");
  const ignoreNewBooking = t(
    "booking.formLabel.conflictsDetails.ignoreNewBooking",
  );
  const allowShiftInsideShift = t(
    "booking.formLabel.conflictsDetails.allowShiftInsideShift",
  );
  const cancelOldBooking = t(
    "booking.formLabel.conflictsDetails.cancelOldBooking",
  );
  const createAnyway = t("booking.formLabel.conflictsDetails.createAnyway");
  const dontCreate = t("booking.formLabel.conflictsDetails.dontCreate");

  // RYDE-7139: removed with the "existing ride" radio — see note above.
  // const createIfExistingFormAttributes = useMemo(
  //   () => ({
  //     radioGroupItems: [
  //       { label: overwrite, value: true },
  //       { label: ignoreNewBooking, value: false },
  //     ],
  //   }),
  //   [ignoreNewBooking, overwrite],
  // );

  const createIfInsideFormAttributes = useMemo(
    () => ({
      radioGroupItems: [
        {
          label: allowShiftInsideShift,
          value: true,
        },
        {
          label: ignoreNewBooking,
          value: false,
        },
      ],
    }),
    [allowShiftInsideShift, ignoreNewBooking],
  );

  const createIfOverlapFormAttributes = useMemo(
    () => ({
      radioGroupItems: [
        {
          label: cancelOldBooking,
          value: true,
        },
        {
          label: ignoreNewBooking,
          value: false,
        },
      ],
    }),
    [cancelOldBooking, ignoreNewBooking],
  );

  const createIfIneligibleFormAttributes = useMemo(
    () => ({
      radioGroupItems: [
        {
          label: createAnyway,
          value: true,
        },
        {
          label: dontCreate,
          value: false,
        },
      ],
    }),
    [createAnyway, dontCreate],
  );

  return {
    // createIfExistingFormAttributes, // RYDE-7139: removed with the "existing ride" radio
    createIfInsideFormAttributes,
    createIfOverlapFormAttributes,
    createIfIneligibleFormAttributes,
  };
};
